import { render, staticRenderFns } from "./Ipag.vue?vue&type=template&id=4c110cf2&"
import script from "./Ipag.vue?vue&type=script&lang=js&"
export * from "./Ipag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports